module.exports = __webpack_public_path__ + "img/2.de41cdb7.png";